import { Link } from "react-router-dom";
import { t } from "ttag";

import { MODAL_ROUTES, ROUTES, useNavigateModal } from "@/app/router";
import { usePortalUserStore } from "@/app/stores";
import { Button, CircleIcon, FolderCheckIcon } from "@/shared/ui";
import { DocumentCard } from ".";

export const DocumentCenterMedicalRecords = () => {
  const navigateModal = useNavigateModal();

  const hasActiveSubscription = usePortalUserStore(
    (state) => state.hasActiveSubscription,
  );

  return (
    <DocumentCard.Root>
      <DocumentCard.Banner>
        <CircleIcon icon={FolderCheckIcon} size="lg" />
      </DocumentCard.Banner>

      <DocumentCard.Content>
        <DocumentCard.Title>{t`Other Documents`}</DocumentCard.Title>
        <DocumentCard.Description>{t`Your dietitian notes, medical records and more.`}</DocumentCard.Description>
      </DocumentCard.Content>

      <DocumentCard.Actions>
        <Button asChild variant="secondary" size="lg">
          <Link
            to={ROUTES.DOCUMENT_CENTER.MEDICAL_RECORDS}
          >{t`View details`}</Link>
        </Button>

        {hasActiveSubscription && (
          <Button
            onClick={() =>
              navigateModal(MODAL_ROUTES.DOCUMENT_CENTER.MEDICAL_RECORDS)
            }
            size="lg"
          >
            {t`Upload medical records`}
          </Button>
        )}
      </DocumentCard.Actions>
    </DocumentCard.Root>
  );
};
